'use client'

import { useCurrentUser } from '@lastbrand/fe-common/universal-auth'
import { useEffect, useRef, useState } from 'react'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { isEmpty } from '@src/utils/functions/utils'

export function useGladlyChat() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { user } = useCurrentUser()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { name, email } = user ?? {}
  // Use MutableRefObject by using any type
  const gladlyRef = useRef<typeof window.Gladly | null>(null)
  const [gladlyLoaded, setGladlyLoaded] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    timer = setInterval(() => {
      if (gladlyRef.current) {
        if (timer) clearInterval(timer)
        return
      }

      if (window.Gladly?.on) {
        // Use type assertion to override readonly
        gladlyRef.current = window.Gladly
        setGladlyLoaded(true)

        if (timer) clearInterval(timer)
      }
    }, 100)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(() => {
    let unsubscribe: (() => void) | undefined = undefined
    if (gladlyLoaded && gladlyRef.current) {
      // eslint-disable-next-line i18next/no-literal-string, @typescript-eslint/no-unsafe-call
      unsubscribe = gladlyRef.current.on('sidekick:opened', (properties: Record<string, unknown>) => {
        // eslint-disable-next-line i18next/no-literal-string
        console.info('Gladly sidekick:opened', { properties })
        trackEvent(TELEMETRY_EVENT_NAMES.SUPPORT_CHAT_INITIATED, {})
      })
    }

    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [gladlyLoaded])

  const setGladlyUser = () => {
    if (email && !isEmpty(window.Gladly?.getUser())) {
      try {
        // @i18n-ignore
        window.Gladly?.setUser({ name, identity: email, identityType: 'EMAIL' })
      } catch (error) {
        console.error(error)
      }
    }
  }

  const openChat = () => {
    try {
      window.Gladly?.show()
      trackEvent(TELEMETRY_EVENT_NAMES.CHAT_WITH_US_CLICKED, {})
      setGladlyUser()
    } catch (error) {
      console.error(error)
    }
  }

  return { openChat }
}
